export const GET_DEPARTAMENT = 'GET_DEPARTAMENT'
export const GET_AGENTS = 'GET_AGENTS'

